import { makeStyles } from "tss-react/mui";
const useDatePickerFooterRangeModeClasses = makeStyles()(() => {
  return {
    datePickerFooterRangeModeInput: {
      marginBottom: 0
    }
  };
});
export {
  useDatePickerFooterRangeModeClasses
};
//# sourceMappingURL=DatePickerFooterRangeMode.style.js.map
